import React, {useState} from "react";
import StoryblokLink from "../storyblokLink/StoryblokLink";
import StoryblokImage from "../storyblokImage/StoryblokImage";
import ImageSelectIcon from '../../../../static/images/image-select-icon.svg';
import ImageSelectIconWhite from '../../../../static/images/image-select-icon-white.svg';
import * as styles from "./ClickableImage.module.scss"
const ClickableImage = ({ image, imageLink, isModal, modalId, modal, buttonTheme }) => {
  const [modalShow, setModalShow] = useState(false);
  const showModal = () => setModalShow(true);
  if (
    imageLink &&
    imageLink.url &&
    imageLink.url.fieldtype &&
    !isModal
  ) {
    return (
      <StoryblokLink
        SBLinkData={imageLink.url}
      >
          <StoryblokImage sbImageData={image} />
      </StoryblokLink>
    );
  }
  return (
    <div>
      {/* Handles if the CTA button links to a modal or if it's going to a url */}
      {/* {isModal ? ( */}
        {/* <a
          className="btn image_button"
          href="javascript:void(0)"
          onClick={showModal}
          datapropmodal={modalId}
        > */}
          <div className={styles.clickableImageContainer}>
            <StoryblokImage sbImageData={image}/>
            <div className={buttonTheme && buttonTheme === 'green' ? styles.imageSelectIconGreen : styles.imageSelectIcon} >
                {buttonTheme && buttonTheme === 'green' ? <img src={ImageSelectIconWhite} />: <img src={ImageSelectIcon} />}
            </div>
          </div>
        {/* </a> */}
      {/* )  */}
      {/* : (
        []
      )} */}
    </div>
  );
};

export default ClickableImage;
